var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "pano-viewer",
      staticStyle: { display: "none", width: "100%", height: "100%" },
      attrs: { id: "id" },
    },
    [
      _c(
        "div",
        { staticClass: "krpano-overlay", class: { hidden: !_vm.showIndex } },
        [
          _c("a", {
            staticClass: "krpano-index-toggle",
            attrs: { href: "#" },
            on: {
              click: function ($event) {
                $event.preventDefault()
                return _vm.toggleIndex()
              },
            },
          }),
          _vm._v(" "),
          _vm.logo
            ? _c("responsive-image", {
                staticClass: "pano-logo",
                attrs: { "img-class": "img-responsive", src: _vm.logo },
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.title ? _c("h2", [_vm._v(_vm._s(_vm.title))]) : _vm._e(),
          _vm._v(" "),
          _vm.debug
            ? _c("div", { staticClass: "alert alert-warning" }, [
                _vm._v(
                  "\n          Aktive Szene: " +
                    _vm._s(_vm.activeScene) +
                    "\n        "
                ),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.scenes
            ? _c(
                "div",
                { staticClass: "krpano-index" },
                _vm._l(_vm.scenes, function (category) {
                  return _c("div", [
                    category.handle
                      ? _c(
                          "a",
                          {
                            staticClass: "pano-switch",
                            class: {
                              active: category.handle === _vm.activeScene,
                            },
                            attrs: { href: "JavaScript:void(0)" },
                            on: {
                              click: function ($event) {
                                return _vm.changeScene(category.handle)
                              },
                            },
                          },
                          [_vm._v(_vm._s(category.title))]
                        )
                      : category.title
                      ? _c(
                          "span",
                          {
                            staticClass: "pano-switch",
                            attrs: { href: "JavaScript:void(0)" },
                          },
                          [_vm._v(_vm._s(category.title))]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    category.scenes
                      ? _c(
                          "ul",
                          _vm._l(category.scenes, function (scene) {
                            return _c("li", [
                              _c(
                                "a",
                                {
                                  staticClass: "pano-switch",
                                  class: {
                                    active: scene.handle === _vm.activeScene,
                                  },
                                  attrs: {
                                    "data-pano-item": scene.handle,
                                    href: "JavaScript:void(0)",
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.changeScene(scene.handle)
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    _vm._s(scene.title) + "\n                  "
                                  ),
                                  _vm.debug
                                    ? _c("span", [
                                        _vm._v(
                                          "handle: " + _vm._s(scene.handle)
                                        ),
                                      ])
                                    : _vm._e(),
                                ]
                              ),
                            ])
                          }),
                          0
                        )
                      : _vm._e(),
                  ])
                }),
                0
              )
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _vm.showPano
        ? _c("krpano", {
            staticStyle: { width: "100%", height: "100%" },
            attrs: {
              xml: _vm.xml,
              "lazy-load": _vm.lazyLoad,
              scene: _vm.activeScene,
              debug: _vm.debug,
              hooks: _vm.hooks,
              consolelog: _vm.debug,
              initvars: {
                hotspot_dir: _vm.hotspot_dir,
                pano_image_dir: _vm.pano_image_dir,
              },
            },
            on: { panoCreated: _vm.panoCreated },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }